import React from 'react';
import { translationClasses } from 'src/shared/TranslationClasses';
import { C23ContentFeedForLocalSiteProps } from './C23ContentFeedForLocalSite.types';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { ContentFeedWithFeaturedCard } from '@ahc-digital/component-library';
import { CreateContentFeedForLocalSiteModel } from './C23ContentFeedForLocalSite.service';
import { PromptForNoArticleResults } from 'src/shared/PromptForNoArticleResults';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { getCheckbox } from 'src/shared/param-utils';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';

export const Default = (props?: C23ContentFeedForLocalSiteProps): JSX.Element => {
  const { renderImage } = useConditionalRendering();
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;

  if (
    Object.keys(props?.fields?.ContentWithFeaturedCard?.FeaturedCards?.articles || {}).length === 0
  )
    return <PromptForNoArticleResults fieldName={'ArticleRoot'} rendering={props?.rendering} />;
  return (
    <ContentFeedWithFeaturedCard
      {...CreateContentFeedForLocalSiteModel(props)}
      id={props?.params?.AnchorLinkTargetName}
      className={translationClasses(props?.params)}
      data-component={marketingRenderingName}
      shouldLazyLoad={getCheckbox(props?.params?.ShouldLazyLoad)}
      placeholderImage={renderImage(props?.fields?.ContentWithFeaturedCard?.PlaceholderImage)}
    />
  );
};
